import type { TFunction } from 'i18next';
import { LoaderIcon } from 'lucide-react';

import { toast } from '@/lib/flashka-toast';

export const UPDATE_TOAST_ID = 'flashka-update-available';

/**
 * The "new version available" toast. Split from `use-auto-update.tsx` (which
 * reads `import.meta.env` and so cannot be loaded under jest) so its options
 * can be pinned by a spec.
 *
 * `dismissible: false` — this toast ALONE cannot be swiped away. Users were
 * swiping it and staying on the stale build (the re-assert only came back on
 * the next poll), so the ONLY way out is the Reload action. Every other toast
 * keeps its default dismissability; do not copy this elsewhere.
 */
export function showUpdateAvailableToast(t: TFunction): void {
  toast(t('toast.app-update-available.title'), {
    id: UPDATE_TOAST_ID,
    description: t('toast.app-update-available.description'),
    duration: Infinity,
    dismissible: false,
    icon: LoaderIcon,
    action: {
      label: t('toast.app-update-available.action'),
      onClick: () => window.location.reload(),
    },
  });
}
